import { ExodusResources } from './exodus.resource';
export const PatientUrl = {
    PATIENT: ExodusResources.PATIENT_ACCOUNT,
    PATIENT_INIT: ExodusResources.PATIENT_ACCOUNT + '/init',
    PATIENT_GET: ExodusResources.PATIENT_ACCOUNT,
    PATIENT_ADD: ExodusResources.PATIENT_ACCOUNT,
    PATIENT_UPDATE: ExodusResources.PATIENT_ACCOUNT + '/{id}',
    PATIENT_GET_CONSULTATIONS: ExodusResources.PATIENT_ACCOUNT + '/consultations',
    PATIENT_GET_ADMINISTEREDVACCINE: ExodusResources.PATIENT_ACCOUNT + '/administered-vaccines',
    PATIENT_GET_OTHER_ADMINISTEREDVACCINE: ExodusResources.PATIENT_ACCOUNT + '/other-administered-vaccines',
    PATIENT_GET_VACCINATION: ExodusResources.PATIENT_ACCOUNT + '/vaccinations',
    PATIENT_ADD_AUDIT_TRAIL: ExodusResources.PATIENT_ACCOUNT + '/audit-trail',
    PATIENT_DOWNLOAD_ATTACHMENT: ExodusResources.PATIENT_ACCOUNT + '/download-attachment',
    PATIENT_MY_PRESCRIPTIONS: ExodusResources.PATIENT + '/{id}/my-prescriptions',
    PATIENT_MY_MEDICAL_CONDITIONS: ExodusResources.PATIENT + '/{id}/my-medical-conditions',
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/patient.url.ts